import {emailValidation} from '../../_Global/js/utils';

window.onload = function () {
  // Initially show the intro content and hide the form and message
  const introDiv = document.querySelector('.leadcap-cta-banner .single-column__content.intro');
  const formDiv = document.querySelector('.leadcap-cta-banner #form-iframe');
  const form = document.querySelector('.leadcap-cta-banner form');
  const formSubmissionUrl = form?.getAttribute('action');
  const messageDiv = document.querySelector('.leadcap-cta-banner .message');
  const currentUrlHiddenInput = document.querySelector('.leadcap-cta-banner [data-role="currentPageUrlInput"]');

  // Ensure elements exist before trying to manipulate them
  if (introDiv) introDiv.classList.remove('hidden'); // Show intro
  if (formDiv) formDiv.classList.add('hidden'); // Hide form initially
  if (messageDiv) messageDiv.classList.add('hidden'); // Hide message initially

  // Handle leadcap button click to show the form
  const button = document.querySelector('.leadcap-cta-banner .intro #leadcap-form-button');

  button?.addEventListener('click', function (event) {
      event.preventDefault();
      const component = button.closest('.leadcap-cta-banner');

      if (component) {
          const contentDiv = component.querySelector('.intro');
          const iframeDiv = component.querySelector('#form-iframe');
          const container = component.querySelector('.call-to-action__container');

          if (contentDiv) {
              contentDiv.classList.add('hidden');
              contentDiv.classList.add('form-matrix--leadcap');
          } // Hide intro content
          if (iframeDiv) iframeDiv.classList.remove('hidden'); // Show form
          if (container) container.classList.add('form-matrix--leadcap-contents'); // Remove max height on cta for form and validation
          if (form) form.classList.remove('hidden'); // Show the form after initial button Leadcap submit
      }
  });

  // Handle form submission
  const firstNameField = form?.querySelector('[data-role="q1Input"]');
  const lastNameField = form?.querySelector('[data-role="q2Input"]');
  const orgField = form?.querySelector('[data-role="q3Input"]');
  const jobTitleField = form?.querySelector('[data-role="q4Input"]');
  const emailField = form?.querySelector('[data-role="q5Input"]');

  // Populate the hidden URL field
  if (currentUrlHiddenInput) {
    currentUrlHiddenInput.value = encodeURI(window.location.href);
  }

  // Function to validate a field
  function validateField(field, minLength = 2, maxLength = 160) {
      const value = field.value.trim();
      if (field !== emailField) return value.length >= minLength && value.length <= maxLength;
      if (field == emailField) return emailValidation(value);
  }

  // Function to show the error
  function showError(fieldWrapper) {
      const error = fieldWrapper.querySelector('.sq-form-error');
      if (error) {
          error.classList.remove('hidden');
      }
  }

  // Function to hide the error
  function hideError(fieldWrapper) {
      const error = fieldWrapper.querySelector('.sq-form-error');
      if (error) {
          error.classList.add('hidden');
      }
  }

  form?.addEventListener('submit', function (event) {
      event.preventDefault(); // Prevent default form submission

      let valid = true;

      const fieldsToValidate = [
          {field: firstNameField, wrapper: form?.querySelector('[data-role="q1Wrapper"]')},
          {field: lastNameField, wrapper: form?.querySelector('[data-role="q2Wrapper"]')},
          {field: orgField, wrapper: form?.querySelector('[data-role="q3Wrapper"]')},
          {field: jobTitleField, wrapper: form?.querySelector('[data-role="q4Wrapper"]')},
          {field: emailField, wrapper: form?.querySelector('[data-role="q5Wrapper"]')},
      ];

      fieldsToValidate.forEach(({wrapper}) => hideError(wrapper));

      fieldsToValidate.forEach(({field, wrapper}) => {
          if (!validateField(field)) {
              showError(wrapper);
              valid = false;
          }
      });

      if (valid) {
          const formData = new FormData(form);
          const submitButton = form?.querySelector('[data-role="formSubmit"]');
          formData.append(submitButton.name, submitButton.value);

          if (formDiv) formDiv.classList.add('hidden'); // Hide form
          if (messageDiv) messageDiv.classList.remove('hidden'); // Show thank you message

          fetch(formSubmissionUrl, {
              method: 'POST',
              body: formData,
          })
          .then((response) => {
              if (response.ok) {
                  // console.log('Form submitted successfully!');
              } else {
                  console.error('Error submitting form', response);
              }
          })
          .catch((error) => {
              console.error('Network error:', error);
          });
      }
  });
};
